import { Project } from '@constants/router.const';
import { Ng2StateDeclaration } from '@uirouter/angular';

export const AGENT_VIEW_MODULE_STATE: Ng2StateDeclaration = {
  name: `dice.${Project.AGENT_VIEW}.**`,
  url: '/agent-view',
  loadChildren: () => import('@agent-view/app/agent-view.module').then((m) => m.AgentViewModule),
};
export const APP_STATES = [AGENT_VIEW_MODULE_STATE];
